var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditBlack = function SvgEditBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m9.208 4.217-4 .011a2 2 0 0 0-1.994 2.006l.023 8.036a2 2 0 0 0 2.006 1.994l8.036-.024a2 2 0 0 0 1.994-2.005l-.012-4m-1.056-7.068a1.465 1.465 0 1 1 2.077 2.065l-6.54 6.578-2.76.699.683-2.764z"
  })));
};
export default SvgEditBlack;